
























// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import TheFormAddresses from '@/components/addresses/TheFormAddresses.vue';
// Importing functions
import {validateAddress} from '@/ts/profile/addresses/validate-address';
import {putAddress} from '@/ts/profile/addresses/put-address';
import {getAddressData} from '@/ts/profile/addresses/get-address-data';
import {getTown} from '@/ts/ekatte/get-town';

export default {
    name: 'PageAddressesUpdate',
    components: {
        LayoutApp,
        BaseCard,
        BaseLoadingAnimation,
        TheFormAddresses,
    },
    props: {},
    data() {
        return {
            data: {},
            items: [],
            errors: [],
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateAddress(this.errors, this.data);

            if (this.errors.length === 0) {
                // Starting animation
                this.$store.dispatch('setLoadingOn');
                putAddress(this.$route.params.id, this.data).then(() => {
                    this.$router.push({ name: 'addresses' });
                }).finally(() => {
                    this.$store.dispatch('setLoadingOff');
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Адреси',
            to: { path: '/addresses' },
        }, {
            text: 'Редактиране',
        }];
        // Initializing the data object
        this.data = {
            name: '', phone: '', address: '', town_ekatte: '',
        };
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getAddressData(this.$route.params.id).then((response: any) => {
            this.data = response;
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
